/** 统一处理 Cookie */

// import { CHANNEL_NAME } from '@/constants/cache-key'

import CacheKey from '@/constants/cache-key'
// import Cookies from 'js-cookie'
import { getAccessToken, setAccessToken } from './local-storage'

export const getToken = () => {
  // return Cookies.get(CacheKey.TOKEN)
  return getAccessToken(CacheKey.TOKEN)
}
export const setToken = (token: string) => {
  // const bc = new BroadcastChannel(CHANNEL_NAME)
  // bc.postMessage({ cookieValue: token })
  // console.log('setToken', token)
  // Cookies.set(CacheKey.TOKEN, token)
  // 不想用local
  setAccessToken(CacheKey.TOKEN, token)
}
export const removeToken = () => {
  // Cookies.remove(CacheKey.TOKEN)
  setAccessToken(CacheKey.TOKEN)
}
export const parseJwt = (token: string) => {
  try {
    // 分割 token
    const base64Url = token.split('.')[1]
    // Base64Url 转 Base64（替换字符）
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    // 解码 Base64
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('解析 JWT 失败', error)
    return null
  }
}
